module.exports = __webpack_public_path__ + "static/media/kocka5POLIGLOT.845977a3.png";